// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"b0985f29","623":"b0985f29"}[chunkId] + ".chunk.css";
};